import { createContext, useContext, useEffect, useState } from "react";
import portalApi from "@/lib/portalApi";

const PortalAuthCtx = createContext({ client: null, loading: true, refresh: () => {}, logout: () => {} });

export function PortalAuthProvider({ children }) {
    const [client, setClient] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = async () => {
        setLoading(true);
        try {
            const r = await portalApi.get("/me");
            setClient(r.data);
        } catch { setClient(null); }
        setLoading(false);
    };

    const logout = async () => {
        try { await portalApi.post("/logout"); } catch {}
        setClient(null);
    };

    useEffect(() => { refresh(); /* eslint-disable-next-line */ }, []);

    return (
        <PortalAuthCtx.Provider value={{ client, loading, refresh, logout }}>
            {children}
        </PortalAuthCtx.Provider>
    );
}

export const usePortalAuth = () => useContext(PortalAuthCtx);
